export default __webpack_public_path__ + "7f3c4a531962aa8ee2f15c6199c1ddb9.png";